import React from 'react';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import {whatsAppLink} from '../util/social.js';
import SCButton from './SCButton.js';

const WhatsAppButton = props=>{
    let {text, message, variant='outlined'} = props;
    return <SCButton text={text} variant={variant} icon={<WhatsAppIcon/>}
      onClick={()=>window.open(whatsAppLink(message), '_blank', 'rel=noopener noreferrer')}/>;
};

export default WhatsAppButton;
